import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';
import { styled } from '@zoopla-eng/zds-components/themes';

export const SuccessContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '&:focus': {
        outline: 'none'
    },
    '&:focus-visible': {
        outline: 'none',
        boxShadow: '$focusRing'
    }
});

export const SuccessMessage = styled('p', {
    fontGroup: 'ladle',
    color: '$textTitle'
});

export const StyledTitle = styled(PageSubtitleShort, {
    fontGroup: 'whisk'
});
